/**
 * Syncfusion License Registration
 * 
 * This file MUST be imported BEFORE any Syncfusion component imports.
 * Import this at the top of any file that uses Syncfusion components.
 */
import { registerLicense } from '@syncfusion/ej2-base';

const SYNCFUSION_LICENSE_KEY = process.env.REACT_APP_SYNCFUSION_API_KEY || 
  'Ngo9BigBOggjHTQxAR8/V1JGaF5cXGpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWX5ccnVVRWBZWEZxVkdWYEs=';

// Log license information for debugging
if (typeof window !== 'undefined') {
  console.log('🔐 Syncfusion License Registration:', {
    hasKey: !!SYNCFUSION_LICENSE_KEY,
    keyLength: SYNCFUSION_LICENSE_KEY?.length || 0,
    fromEnv: !!process.env.REACT_APP_SYNCFUSION_API_KEY,
    environment: process.env.NODE_ENV,
    domain: window.location.hostname,
  });
}

// Register immediately when this module is loaded
try {
  registerLicense(SYNCFUSION_LICENSE_KEY);
  console.log('✅ Syncfusion license registered successfully');
} catch (error) {
  console.error('❌ Failed to register Syncfusion license:', error.message);
}

export default SYNCFUSION_LICENSE_KEY;
